'use client';

import { c as _c } from "react/compiler-runtime";
import { useStore } from 'jotai';
import { useRef } from 'react';
import { bodyBgColorAtom } from '@/atoms';
import { useStyleObserver } from '@sub-vocab/utils/hooks';
export function Body(t0) {
  const $ = _c(5);
  const {
    children
  } = t0;
  const ref = useRef(null);
  const store = useStore();
  let t1;
  if ($[0] !== store) {
    t1 = t2 => {
      const [t3] = t2;
      const {
        value
      } = t3;
      store.set(bodyBgColorAtom, value);
    };
    $[0] = store;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      properties: ["background-color"]
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  useStyleObserver(ref, t1, t2);
  let t3;
  if ($[3] !== children) {
    t3 = <body ref={ref} className="overflow-y-scroll tracking-[.03em] text-foreground font-stretch-93% antialiased">{children}</body>;
    $[3] = children;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}